// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.c_lE3{border-radius:8px;display:flex;flex-direction:column;width:100%}.N6l3O{overflow:visible}.UBWZP{margin:5px 0 12px 63px}`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"tableWrapper": `c_lE3`,
	"visibleOverflow": `N6l3O`,
	"chargesContainer": `UBWZP`
};
export default ___CSS_LOADER_EXPORT___;
